import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import useMediaQuery from '@mui/material/useMediaQuery';
import ToolsWalkthroughContent from './tools_walkthrough_content';

const style = {
    position: "absolute",
    top: "4%",
    left: "10%",
    height: "92%",
    width: "70%",
    minWidth: "600px",
    minHeight: "400px",
    maxWidth: "95vw",
    maxHeight: "95vh",
    bgcolor: "#0d2147",
    boxShadow: 24,
    borderRadius: 2,
    overflow: "auto",
    resize: "both",
};

export default function ToolsWalkthroughPopup({
    open,
    onClose,
    initialActiveId = "overview",
}) {
  const isBigScreen = useMediaQuery('(min-width:1024px)');

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="tools-walkthrough" aria-describedby="tools-walkthrough-desc">
      <Box id="tools-walkthrough-coach-anchor" sx={style}>
        <Box
          sx={{
            display: 'flex',
            mt: 0,
            pt: 0,
            background: '#132d5a',
            width: '100%',
            height: '100%',
            overflow: 'auto',
            p: 0,
            scrollBehavior: 'smooth',
            '&::-webkit-scrollbar': { width: 6, height: 6 },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#3F69F8', borderRadius: 3 },
            flexDirection: isBigScreen ? 'row' : 'column',
            alignItems: 'stretch',
          }}
        >
          <ToolsWalkthroughContent
            key={initialActiveId}
            onBack={onClose}
            initialActiveId={initialActiveId}
          />
        </Box>
      </Box>
    </Modal>
  );
}
